import { render, staticRenderFns } from "./NotificationOfOrganizationAcceptanceDialog.vue?vue&type=template&id=1ce142dc&"
import script from "./NotificationOfOrganizationAcceptanceDialog.vue?vue&type=script&lang=js&"
export * from "./NotificationOfOrganizationAcceptanceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports